import t from "./design-system.es895.js";
function a(r) {
  var o = t(r), e = o.pageXOffset, l = o.pageYOffset;
  return {
    scrollLeft: e,
    scrollTop: l
  };
}
export {
  a as default
};
//# sourceMappingURL=design-system.es944.js.map
